import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { ModalDialog, ModalDialogMessages as sharedMsgs, generateValidation } from 'ecs-react-components/dist/index.es';
import { DedicatedWorkflowPanel } from '../../../components/SystemShared/DedicatedWorkflowPanel';
import { messages } from '../../../containers/SignUp/CreateAccount/CreateAccountForm.i18n';
import CreateAccountForm from '../../../containers/SignUp/CreateAccount/CreateAccountForm';
import { clearPatientData } from '../../../redux/modules/signup/create-account/create-account-action-creator';
import { getValidations } from '../../../containers/SignUp/CreateAccount/CreateAccountForm.validations';

class CreateAccountPage extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowCancelModal: false,
      nextRoute: '',
    };
  }

  componentDidMount() {
    if (!this.props.patient.patientId && !this.props.authorizedRepData.email) {
      this.props.history.push('/');
    }

    this.allowRouteToChange = false;

    if (this.props.history) {
      this.unblockRouter = this.props.history.block(this.leaveHook.bind(this));
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  setNoModalToRoute = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;
  }

  leaveHook = (next) => {
    let showCancelModal = true;

    if (next.pathname === '/' || next.pathname === '/dashboard') {
      showCancelModal = false;
      this.allowRouteToChange = true;
    }

    if (!this.state.isShowCancelModal) {
      this.setState({
        isShowCancelModal: showCancelModal,
        nextRoute: next.pathname,
      });
    }

    return this.allowRouteToChange;
  }

  hideCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = false;
    this.props.history.push('/create-account');
  }

  submitCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;
    this.props.dispatch(clearPatientData());
    this.props.history.push(this.state.nextRoute);
  }

  allowRouteToChange = false;

  render() {
    const { minLength, capitalLetters, numbers, specialCharacters } = this.props;

    return (
      <DedicatedWorkflowPanel headerTitle={ messages.page.title } >
        <CreateAccountForm {
          ...generateValidation(getValidations(minLength, capitalLetters, numbers, specialCharacters))}
        />
        <ModalDialog show={this.state.isShowCancelModal}
          title={sharedMsgs.cancelModal.title}
          message={sharedMsgs.cancelModal.message }
          submitBtnText={ sharedMsgs.cancelModal.submitBtnText }
          hideBtnText={sharedMsgs.cancelModal.hideBtnText.button}
          submitBtnTextDescription={ sharedMsgs.cancelModal.submitBtnTextDescription}
          hideBtnTextDescription={sharedMsgs.cancelModal.hideBtnText.description}
          onSubmit={this.submitCancelModal}
          onHide={this.hideCancelModal}
          id={1}
        />
      </DedicatedWorkflowPanel>
    );
  }
}

CreateAccountPage.propTypes = {
  history: PropTypes.object,
  dispatch: PropTypes.func,
  patient: PropTypes.object,
  minLength: PropTypes.number,
  capitalLetters: PropTypes.number,
  numbers: PropTypes.number,
  specialCharacters: PropTypes.number,
  authorizedRepData: PropTypes.object,
};

const mapStateToProps = (state) => {
  let typedMinLength = 0;
  let typedCapitalLetters = 0;
  let typedNumbers = 0;
  let typedSpecialCharacters = 0;
  if (state.signUp.password) {
    typedMinLength = state.signUp.password.minLength;
    typedCapitalLetters = state.signUp.password.capitalLetters;
    typedNumbers = state.signUp.password.numbers;
    typedSpecialCharacters = state.signUp.password.specialCharacters;
  }
  return {
    patient: state.profile.patient,
    minLength: typedMinLength,
    capitalLetters: typedCapitalLetters,
    numbers: typedNumbers,
    specialCharacters: typedSpecialCharacters,
    authorizedRepData: state.signUp.authorizedRepData,
  };
};

export default withRouter(connect(mapStateToProps)(CreateAccountPage));